import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {DateFormatService} from 'dmmp-services'

@Component({
  selector: 'dmmp-card-event',
  templateUrl: './card-event.component.html',
})
export class CardEventComponent implements OnInit {
  @Input() showImage = true
  @Input() category: string
  @Input() title: string
  @Input() image = []
  @Input() date: Date
  @Input() description: string
  @Input() descriptionSize: number
  @Input() classDate: string
  @Input() classHour: string
  @Input() classDescription: string
  @Input() classCategory: string
  @Input() classTitle: string
  @Input() classImage: string
  @Input() medias = [
    {style: 'max_650x650', media: '(min-width:351px)'},
    {style: 'file_entity_browser_thumbnail', media: '(max-width:350px) AND (min-width:326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]
  @Input() path: string
  @Output() redirectPage = new EventEmitter()
  hoursText = 'hs.'

  constructor(public dateFormatService: DateFormatService) {
  }

  ngOnInit() {
    this.date = this.dateFormatService.convertFromTimestampToDate(this.date)
  }
}
